import React from "react";

// A single list-row skeleton (icon tile + two text lines + trailing badge).
export function SkeletonRow() {
  return (
    <div className="flex items-center gap-3 rounded-2xl glass-card p-4" aria-hidden="true">
      <div className="w-11 h-11 rounded-xl skeleton shrink-0" />
      <div className="flex-1 space-y-2">
        <div className="h-3.5 w-2/5 rounded-full skeleton" />
        <div className="h-2.5 w-3/5 rounded-full skeleton" />
      </div>
      <div className="h-6 w-8 rounded-md skeleton shrink-0" />
    </div>
  );
}

// A list of skeleton rows, used while data is loading.
export function SkeletonList({ count = 4, testid }) {
  return (
    <div className="space-y-3" data-testid={testid}>
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonRow key={i} />
      ))}
    </div>
  );
}
